import { useTranslation } from 'react-i18next';
import { Check, X } from 'lucide-react';
import { log } from '../../utils/logger';
import '../shared/offer-bar.css';
import './RematchPanel.css';

interface IncomingRematchPromptProps {
  onAccept: () => void;
  onDecline: () => void;
}

/**
 * «L'avversario vuole la rivincita!» piu' Accetta/Rifiuta.
 *
 * Sta in un componente suo perche' va montato in DUE posti: nel pannello di fine
 * partita e dentro il riquadro `GameOverOverlay`. Il riquadro e' un modale che
 * resta aperto finche' non lo si chiude a mano, e chi RICEVE la proposta e'
 * quasi sempre ancora li' sopra — chi la manda ha dovuto chiuderlo per premere il
 * bottone. Senza la copia nel modale la proposta arrivava e restava invisibile,
 * per quanto la si colorasse. Stesso rimedio, e stessa ragione, di
 * ReturnLegCountdown.
 *
 * Una scatola sola — messaggio sopra, i due bottoni sotto — come la proposta di
 * patta nella barra di gioco: `.rematch-actions` e `.game-toolbar` sono la stessa
 * card fin nei pixel (stessi raggio, ombra, bordo), quindi indossando lo stesso
 * `.offer-bar` le due richieste coincidono invece di somigliarsi.
 */
export default function IncomingRematchPrompt({ onAccept, onDecline }: IncomingRematchPromptProps) {
  const { t } = useTranslation();
  return (
    <div className="rematch-actions offer-bar" data-testid="incoming-rematch-prompt">
      <span className="offer-bar__text">{t('online.rematch.opponentWantsRematch')}</span>
      <button
        type="button"
        className="rematch-btn accept offer-bar__btn--accept"
        onClick={() => {
          log.info('RematchPanel', 'Rematch accepted');
          onAccept();
        }}
      >
        <Check size={20} aria-hidden="true" />
        <span>{t('online.rematch.accept')}</span>
      </button>
      <button
        type="button"
        className="rematch-btn decline offer-bar__btn--decline"
        onClick={() => {
          log.info('RematchPanel', 'Rematch declined');
          onDecline();
        }}
      >
        <X size={20} aria-hidden="true" />
        <span>{t('online.rematch.decline')}</span>
      </button>
    </div>
  );
}
